angular.module('bizmetryApp').controller('UserCreateDialogController', function (
    $scope, $mdDialog, $timeout, $mdToast,
    UserService, dialogService, RolesService,
    roles, accountId
) {

    // ── Init ──────────────────────────────────────────────────────────────────
    $scope.accountId  = accountId;
    $scope.allRoles   = roles || [];
    $scope.creating   = false;
    $scope.activeTab  = 0;

    $scope.newUser = {
        firstName:     '',
        lastName:      '',
        email:         '',
        user2FANumber: ''
    };

    $scope.selectedRoles = [];

    $scope.emailValidation = {
        exists:           false,
        available:        false,
        validatingDomain: false,
        invalidDomain:    false,
        checkFailed:      false
    };

    // ── Password ──────────────────────────────────────────────────────────────
    $scope.passwordValue = '';
    $scope.passwordValid = true;

    $scope.onPasswordChange = function (value, valid) {
        $scope.passwordValue = value;
        $scope.passwordValid = valid;
    };

    // ── 2FA ───────────────────────────────────────────────────────────────────
    $scope.phoneValid     = null;
    $scope.twoFaValidated = false;

    var _validatedPhone = null;

    $scope.$watch('newUser.user2FANumber', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.twoFaValidated = false;
            _validatedPhone = null;
        }
    });

    $scope.$watch('phoneValid', function () { /* fuerza digest para canValidate2FA */ });

    $scope.canValidate2FA = function () {
        return !!(
            $scope.newUser.user2FANumber &&
            $scope.phoneValid === true &&
            !$scope.twoFaValidated
        );
    };

    $scope.phoneNumberChangedAfterValidation = function () {
        return $scope.twoFaValidated &&
            $scope.newUser.user2FANumber !== _validatedPhone;
    };

    $scope.openTwoFaValidation = function () {
        if (!$scope.newUser.email) {
            $mdToast.show($mdToast.simple()
                .textContent('Please enter an email address first')
                .position('top right').hideDelay(2500));
            return;
        }

        $mdDialog.show({
            template: [
                '<two-fa-validator',
                '    email="{{ $ctrl.email }}"',
                '    target-number="{{ $ctrl.targetNumber }}"',
                '    on-success="$ctrl.onSuccess()"',
                '    on-cancel="$ctrl.onCancel()">',
                '</two-fa-validator>'
            ].join(''),
            controller: function ($mdDialog) {
                this.email        = $scope.newUser.email;
                this.targetNumber = $scope.newUser.user2FANumber;
                this.onSuccess    = function () { $mdDialog.hide({ success: true }); };
                this.onCancel     = function () { $mdDialog.cancel(); };
            },
            controllerAs:        '$ctrl',
            clickOutsideToClose: false,
            escapeToClose:       false,
            multiple:            true
        })
        .then(function (result) {
            if (result && result.success) {
                $scope.twoFaValidated = true;
                _validatedPhone = $scope.newUser.user2FANumber;
                $mdToast.show($mdToast.simple()
                    .textContent('✅ Phone number verified')
                    .position('top right').hideDelay(2500));
            }
        })
        .catch(function () {});
    };

    // ── Email validation ──────────────────────────────────────────────────────
    var _emailDebounce = null;

    $scope.checkEmailAvailability = function () {
        var email = $scope.newUser.email;
        $scope.emailValidation = {
            exists: false, available: false,
            validatingDomain: false, invalidDomain: false,
            checkFailed: false
        };

        if (!email || !_isValidEmailFormat(email)) return;

        if (_emailDebounce) $timeout.cancel(_emailDebounce);
        _emailDebounce = $timeout(function () {
            $scope.emailValidation.validatingDomain = true;

            // 👇 antes faltaba pasar accountId: quedaba `undefined` y la URL
            // terminaba en `.../undefined/users/email/...` (500 en el backend)
            UserService.checkEmailExists(email, accountId)
                .then(function (result) {
                    $scope.emailValidation.validatingDomain = false;
                    $scope.emailValidation.exists    = !!result.exists;
                    $scope.emailValidation.available = !result.exists;
                })
                .catch(function (error) {
                    // Error real (500, red, etc.) -> NO lo damos por "disponible".
                    // Antes esto caía acá con cualquier error y marcaba
                    // available = true, mostrando el email como válido aunque
                    // ya existiera.
                    $scope.emailValidation.validatingDomain = false;
                    $scope.emailValidation.available   = false;
                    $scope.emailValidation.checkFailed = true;
                    console.error('checkEmailAvailability -> error validando email:', error);
                });
        }, 400);
    };

    function _isValidEmailFormat(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    // ── Role management ───────────────────────────────────────────────────────
    $scope.getRolesCount = function () {
        return $scope.selectedRoles.filter(function (r) { return r.type !== 'PERMISSION'; }).length;
    };

    $scope.getPermissionsCount = function () {
        return $scope.selectedRoles.filter(function (r) { return r.type === 'PERMISSION'; }).length;
    };

    $scope.removeRole = function (role) {
        $scope.selectedRoles = $scope.selectedRoles.filter(function (r) {
            return r.id !== role.id;
        });
    };

    $scope.openRoleExplorer = function () {
        $mdDialog.show({
            controller:          'RoleExplorerPickerController',
            templateUrl:         '/home/main-menu/users/tabs/user-management/role-picker/role-explorer-picker.html',
            parent:              angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose:       true,
            multiple:            true,
            locals: {
                selectedRoles: angular.copy($scope.selectedRoles),
                accountId:     accountId
            }
        })
        .then(function (result) {
            if (result && result.selectedRoles) {
                $scope.selectedRoles = result.selectedRoles;
            }
        })
        .catch(function () {});
    };

    // ── Form validity ─────────────────────────────────────────────────────────
    $scope.isFormValid = function () {
        var hasName  = !!($scope.newUser.firstName && $scope.newUser.firstName.trim());
        var hasLast  = !!($scope.newUser.lastName  && $scope.newUser.lastName.trim());
        var hasEmail = _isValidEmailFormat($scope.newUser.email || '') &&
                       !$scope.emailValidation.exists &&
                       !$scope.emailValidation.invalidDomain &&
                       !$scope.emailValidation.validatingDomain &&
                       !$scope.emailValidation.checkFailed;
        var hasRoles = $scope.selectedRoles.length > 0;

        var phoneProvided = !!$scope.newUser.user2FANumber;
        var phoneOk       = !phoneProvided ||
                            ($scope.phoneValid === true && $scope.twoFaValidated);

        var pwdOk = !!$scope.passwordValue && $scope.passwordValid === true;

        return hasName && hasLast && hasEmail && hasRoles && phoneOk && pwdOk;
    };

    // ── Create ────────────────────────────────────────────────────────────────
    $scope.createUser = function () {
        if (!$scope.isFormValid() || $scope.creating) return;

        $scope.creating = true;

        var userDTO = {
            firstName:     $scope.newUser.firstName.trim(),
            lastName:      $scope.newUser.lastName.trim(),
            email:         $scope.newUser.email.trim().toLowerCase(),
            password:      $scope.passwordValue,
            user2FANumber: $scope.twoFaValidated ? $scope.newUser.user2FANumber : null,
            userRoles:     $scope.selectedRoles.map(function (r) {
                return { id: r.id, name: r.name, type: r.type };
            })
        };

        UserService.createUser(userDTO, accountId)
            .then(function (response) {
                $scope.creating = false;
                $mdToast.show($mdToast.simple()
                    .textContent('✅ User created successfully!')
                    .position('top right').hideDelay(3000));
                $mdDialog.hide(response.data);
            })
            .catch(function (error) {
                $scope.creating = false;
                var msg = (error.data && error.data.message) || 'Failed to create user';
                dialogService.showErrorDialog('Error Creating User', msg);
            });
    };

    $scope.cancel = function () { $mdDialog.cancel(); };
});